import $ from "jquery";
import appInfo from './config';

$.ajaxSetup({
    headers : {
        'Authorization' : 'Token ' + appInfo.token + ''
    }
});

function sendCallback(q) {
    const apiEndUrl = '/callback'
    let fullUrl = appInfo.devServer + apiEndUrl;

    return $.ajax({
      type: 'POST',
      url: fullUrl,
      dataType: 'json',
      data: q
    });
  }

  export default {
    sendCallback
  }